import { yupDateRangeValidation } from '@product-framework/components/FormFields';
import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      createdDateTime: yupDateRangeValidation({
        testName: 'createdDateTime-value=required-on-operator',
        sameErrMessage: 'Created dates cannot be same for between',
        greaterThnErrMessage:
          'Created date start needs to be greater than end date',
        validBetweenDateMessage:
          'Created date must have 2 valid dates for between',
        requiredMessage: 'Created date is required',
        validDateMessage: 'Created date should be valid date',
      }),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      // eslint-disable-next-line arrow-body-style
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
